// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var getSlateMembers = function (slate) {
    return Object.fromEntries(slate.contests.map(function (_a) {
        var contest = _a.contest, candidates = _a.candidates;
        return [
            contest.id,
            candidates.map(function (candidate) { return candidate.id; }),
        ];
    }));
};
export var ESlateSelectionStatus;
(function (ESlateSelectionStatus) {
    ESlateSelectionStatus["NONE"] = "none";
    ESlateSelectionStatus["PARTLY"] = "partly";
    ESlateSelectionStatus["MIXED"] = "mixed";
    ESlateSelectionStatus["ALL"] = "all";
})(ESlateSelectionStatus || (ESlateSelectionStatus = {}));
/**
 * How much of a slate the ballot currently holds, read from the ordinary
 * candidate selections. No slate choice is stored anywhere: a member chosen
 * one by one counts exactly like one chosen through the slate.
 *
 * The whole ballot is looked at: a slate is ALL only when the ballot holds
 * exactly its candidates and nothing in the offices it has none for. Any
 * other choice next to its members makes it MIXED.
 */
export var getSlateSelectionSummary = function (members, selection) {
    var _a;
    var selectedMemberIds = [];
    var total = 0;
    var hasOutsideChoice = false;
    for (var _i = 0, _b = selection !== null && selection !== void 0 ? selection : []; _i < _b.length; _i++) {
        var contest = _b[_i];
        var memberIds = (_a = members[contest.contest_id]) !== null && _a !== void 0 ? _a : [];
        if (contest.is_explicit_invalid) {
            hasOutsideChoice = true;
        }
        for (var _c = 0, _d = contest.choices; _c < _d.length; _c++) {
            var choice = _d[_c];
            var isMember = memberIds.includes(choice.id);
            var isSelected = choice.selected > -1;
            if (isMember) {
                total += 1;
                if (isSelected) {
                    selectedMemberIds.push(choice.id);
                }
            }
            else if (isSelected) {
                hasOutsideChoice = true;
            }
        }
    }
    var selected = selectedMemberIds.length;
    var status = ESlateSelectionStatus.PARTLY;
    if (selected === 0) {
        status = ESlateSelectionStatus.NONE;
    }
    else if (hasOutsideChoice) {
        status = ESlateSelectionStatus.MIXED;
    }
    else if (selected === total) {
        status = ESlateSelectionStatus.ALL;
    }
    return { status: status, selected: selected, total: total, selectedMemberIds: selectedMemberIds };
};
